import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { AuthService } from '@core/auth/services/auth.service';
import { environment } from '@env';

import { CoreApiErrorHandlerService, CoreAuthServiceBase, CoreStorageService, PnApiError } from 'pn-core-code';

import { MessageService } from 'primeng/api';

interface ErrorDTO {
  message: string;
  title: string;
  statusCode: string;
  errorCode?: string;
}

@Injectable()
export class CustomApiErrorHandlerService extends CoreApiErrorHandlerService {
  constructor(
    private translateService: TranslateService,
    private messageService: MessageService,
    private router: Router,
    private localize: LocalizeRouterService,
    // protected storage: CoreStorageService,
    protected coreAuthServiceBase: CoreAuthServiceBase,
    // private authService: AuthService,
  ) {
    super();
  }

  override handleError(err: HttpErrorResponse): void {
    let result: ErrorDTO = this.convertError(err as PnApiError, environment.env !== 'PROD');
    console.log('handleError --> err', err);


    const errorJson = JSON.parse(err.error);
    if (errorJson.statusCode === 401) {
      // this.router.navigate([environment.loginScreenRoute]);
      if (!_.startsWith(this.router.url, environment.loginScreenRoute)) {

        // this.coreAuthServiceBase.removeAdditionalAuthData();
        this.router.navigate([this.localize.translateRoute('/auth/login')], { replaceUrl: true });
        // this.authService.logout(); 
        // this.router.navigate([this.localize.translateRoute(environment.loginScreenRoute)]);
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: result.title,
        detail: result.message,
        life: 5000
      })
    }

  }

  convertError(err: PnApiError, isDevTest = false): ErrorDTO {
    let result: ErrorDTO = {} as ErrorDTO;
    let commonError = this.translateService.instant('apiError.common');
    try {
      // error message from json
      const error = JSON.parse(err.error);

      if (isDevTest) {
        result = {
          message: `${error.code} - ${error.message}`,
          title: commonError,
          statusCode: `${error.statusCode}`,
          errorCode: error.code
        }
      } else {
        result = {
          message: error.message,
          title: commonError,
          statusCode: `${error.statusCode}`,
          errorCode: error.code
        }
      }

    } catch (e) {
      if (isDevTest) {
        result.message = err as any;
      } else {
        result.message = commonError;
      }
    }

    return result;
  }
}